import React from 'react';
import { compose } from 'ramda';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import CheckBox from '@synergycms_core/components/generic/CheckBox';
import styleFile from './SearchOptionFilterOption.js';

class SearchOptionFilterOption extends React.Component {
  static displayName = 'SearchOptionFilterOption';

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;

    const { onChange, code, data } = config;
    let { type } = config;

    // const innerStyle = ['filterOptions'];

    let richTextConfig = {
      text: data.get('name'),
      innerStyle: ['roboto14Black'],
      ucFirst: true
    };

    const starsConfig = {
      stars: data.get('name'),
      innerStyle: ['starsFont'],
    };

    const additionalRichTextConfig = {
      text: `(${data.get('hotels').size})`,
      innerStyle: ['roboto16Black'],
      ucFirst: true
    };

    // Excepció others
    if (type === 'stars' && data.get('name') === 'others') {
      type = 'others';
      richTextConfig = {
        text: '_%otros%_',
        innerStyle: ['roboto13Black'],
        translate: true,
        ucFirst: true
      };
    }

    return (
      <li className={[classes.option]} key={code}>
        {type === 'stars' ? (
          <CheckBox
            innerStyle={'checkSelected'}
            value={data.get('checked')}
            onChange={onChange(code)}
            stars={starsConfig}
            additionalRichText={additionalRichTextConfig}
            code={code}
          />
        ) : (
            <CheckBox
              innerStyle={'checkSelected'}
              value={data.get('checked')}
              onChange={onChange(code)}
              richText={richTextConfig}
              additionalRichText={additionalRichTextConfig}
              code={code}
            />
          )}
      </li>
    );
  }
}

export default compose(
  PropertyManager(['theme', 'onChange', 'type', 'code', 'data', 'type']),
  withThemeJSS({ styleFile })
)(SearchOptionFilterOption);
